import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Flyer from "./pages/Flyer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/flyer" element={<Flyer />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;